import React from "react";

import TaskWorkflows from "../../TaskWorkflows";

import TaskDetailsWorkflowStandalone from "./TaskDetailsWorkflowStandalone";

interface TaskDetailsWorkflowProps {
  disableDrawerTransition?: boolean;
}

const TaskDetailsWorkflow: React.FC<TaskDetailsWorkflowProps> = ({
  disableDrawerTransition,
}) => {
  return (
    <TaskWorkflows>
      <TaskDetailsWorkflowStandalone
        disableDrawerTransition={disableDrawerTransition}
      />
    </TaskWorkflows>
  );
};

export default TaskDetailsWorkflow;
